<div class="container">
  <div class="content">
    <h2>{{ 'privacy.title' | translate }}</h2>
    <hr class="title-divider" />

    <p>{{ 'privacy.intro1' | translate }}</p>
    <p>{{ 'privacy.intro2' | translate }}</p>
    <p>{{ 'privacy.intro3' | translate }}</p>
    <p>{{ 'privacy.intro4' | translate }}</p>

    <!-- Section I -->
    <h3>{{ 'privacy.section1.heading' | translate }}</h3>
    <p>{{ 'privacy.section1.text' | translate }}</p>
    <div class="address-block">
      <span>{{ 'privacy.section1.company' | translate }}</span>
      <span>{{ 'privacy.section1.street' | translate }}</span>
      <span>{{ 'privacy.section1.city' | translate }}</span>
      <span>{{ 'privacy.section1.country' | translate }}</span>
    </div>
    <div class="contact-block">
      <span>{{ 'privacy.section1.phone' | translate }}</span>
      <span>{{ 'privacy.section1.fax' | translate }}</span>
      <span>{{ 'privacy.section1.email' | translate }}</span>
    </div>

    <!-- Section II -->
    <h3>{{ 'privacy.section2.heading' | translate }}</h3>
    <p>{{ 'privacy.section2.text' | translate }}</p>
    <div class="address-block">
      <span>{{ 'privacy.section2.name' | translate }}</span>
      <span>{{ 'privacy.section2.company' | translate }}</span>
      <span>{{ 'privacy.section2.street' | translate }}</span>
      <span>{{ 'privacy.section2.city' | translate }}</span>
      <span>{{ 'privacy.section2.country' | translate }}</span>
    </div>
    <div class="contact-block">
      <span>{{ 'privacy.section2.phone' | translate }}</span>
      <span>{{ 'privacy.section2.email' | translate }}</span>
    </div>

    <!-- Section III -->
    <h3>{{ 'privacy.section3.heading' | translate }}</h3>

    <h4>{{ 'privacy.section3.sub1.heading' | translate }}</h4>
    <p>{{ 'privacy.section3.sub1.text' | translate }}</p>

    <h4>{{ 'privacy.section3.sub2.heading' | translate }}</h4>
    <p>{{ 'privacy.section3.sub2.text' | translate }}</p>
    <p class="example">{{ 'privacy.section3.sub2.example' | translate }}</p>

    <h4>{{ 'privacy.section3.sub3.heading' | translate }}</h4>
    <p>{{ 'privacy.section3.sub3.text1' | translate }}</p>
    <p>{{ 'privacy.section3.sub3.text2' | translate }}</p>
    <p>{{ 'privacy.section3.sub3.text3' | translate }}</p>
    <p>{{ 'privacy.section3.sub3.text4' | translate }}</p>

    <h4>{{ 'privacy.section3.sub4.heading' | translate }}</h4>
    <p>{{ 'privacy.section3.sub4.text' | translate }}</p>

    <!-- Section IV -->
    <h3>{{ 'privacy.section4.heading' | translate }}</h3>

    <h4>{{ 'privacy.section4.sub1.heading' | translate }}</h4>
    <p>{{ 'privacy.section4.sub1.text' | translate }}</p>
    <ul>
      <li>{{ 'privacy.section4.sub1.field1' | translate }}</li>
      <li>{{ 'privacy.section4.sub1.field2' | translate }}</li>
      <li>{{ 'privacy.section4.sub1.field3' | translate }}</li>
      <li>{{ 'privacy.section4.sub1.field4' | translate }}</li>
      <li>{{ 'privacy.section4.sub1.field5' | translate }}</li>
      <li>{{ 'privacy.section4.sub1.field6' | translate }}</li>
    </ul>
    <p>{{ 'privacy.section4.sub1.consent' | translate }}</p>

    <h4>{{ 'privacy.section4.sub2.heading' | translate }}</h4>
    <p>{{ 'privacy.section4.sub2.text' | translate }}</p>

    <h4>{{ 'privacy.section4.sub3.heading' | translate }}</h4>
    <p>{{ 'privacy.section4.sub3.text' | translate }}</p>

    <!-- Section V -->
    <h3>{{ 'privacy.section5.heading' | translate }}</h3>
    <p>{{ 'privacy.section5.text' | translate }}</p>

    <h4>{{ 'privacy.section5.sub1.heading' | translate }}</h4>
    <p>{{ 'privacy.section5.sub1.text' | translate }}</p>

    <h4>{{ 'privacy.section5.sub2.heading' | translate }}</h4>
    <p>{{ 'privacy.section5.sub2.text' | translate }}</p>

    <h4>{{ 'privacy.section5.sub3.heading' | translate }}</h4>
    <p>{{ 'privacy.section5.sub3.text' | translate }}</p>
    <ul>
      <li>{{ 'privacy.section5.sub3.reason1' | translate }}</li>
      <li>{{ 'privacy.section5.sub3.reason2' | translate }}</li>
      <li>{{ 'privacy.section5.sub3.reason3' | translate }}</li>
      <li>{{ 'privacy.section5.sub3.reason4' | translate }}</li>
      <li>{{ 'privacy.section5.sub3.reason5' | translate }}</li>
      <li>{{ 'privacy.section5.sub3.reason6' | translate }}</li>
    </ul>

    <h4>{{ 'privacy.section5.sub4.heading' | translate }}</h4>
    <p>{{ 'privacy.section5.sub4.text' | translate }}</p>

    <h4>{{ 'privacy.section5.sub5.heading' | translate }}</h4>
    <p>{{ 'privacy.section5.sub5.text1' | translate }}</p>
    <p>{{ 'privacy.section5.sub5.text2' | translate }}</p>
    <p>{{ 'privacy.section5.sub5.text3' | translate }}</p>

    <h4>{{ 'privacy.section5.sub6.heading' | translate }}</h4>
    <p>{{ 'privacy.section5.sub6.text1' | translate }}</p>
    <p>{{ 'privacy.section5.sub6.text2' | translate }}</p>
  </div>
</div>
